<template>
    <div class="chart-view-root" ref="chartViewRoot">
        <h6 v-if="chartSeries != null" class="chart-title" ref="chartTitle">{{ this.chartSeries.title }}</h6>
        <div class="chart-view">        
            <canvas class="chart-canvas" ref="chartCanvas"></canvas>
        </div>
        <a v-if="chartSeries != null" href="#" @click="save">Save</a>
    </div>    
</template>

<script>
import Chart from 'chart.js'
import logger from '@/lib/logger.js'
import FileSaver from 'file-saver'

export default {
    name: 'ChartView',
    data() {
        return {
            chartSeries: null,
            chartData: null,
            chart: null,
        }
    },
    computed: {
    },
    methods: {
        save() {
            //let url = this.chart.toBase64Image()
            this.$refs.chartCanvas.toBlob((blob) => {
                FileSaver.saveAs(blob, 'Chart Export.png')
            })
        },
        updateData(chartData, chartSeries) {
            this.destroyChart()
            this.chartData = chartData
            this.chartSeries = chartSeries
            this.buildChart()
        },
        buildChart() {            
            let datasets = []

            logger.log('Building chart datasets', this.chartSeries)

            this.chartSeries.series.forEach((series) => {                
                let seriesValues = series.values.map((x) => {
                    if (x <= -9999)
                        return NaN
                    return x
                })
                logger.log('series values', seriesValues)
                datasets.push({
                    label: series.name,
                    borderColor: series.color,
                    data: seriesValues
                })
            })

            let chartConfig = {
                type: 'line',
                data: {
                    labels: this.chartData.labels,
                    datasets: datasets
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: this.chartSeries.title
                    }
                }
            }

            if (this.chartSeries.units != '') {
                chartConfig.options.scales = {
                    yAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: this.chartSeries.units
                            }
                        }
                    ]
                }
            }
            
            let ctx = this.$refs.chartCanvas.getContext('2d')            
            this.chart = new Chart(ctx, chartConfig)            
            this.$refs.chartCanvas.style.height = (this.$refs.chartCanvas.clientWidth * 0.4) + 'px'
        },
        destroyChart() {
            if (this.chart != null) {
                this.chart.destroy()
                this.chart = null
            }            
        }
    },
    beforeDestroy() {
        if (this.chart != null) {
            this.destroyChart()
        }
    }
}
</script>

<style>
    .chart-view-root {
        position: relative;
    }

    .chart-view {
        position: relative;
        width: 100%;
    }

    .chart-canvas {
        position: relative;
        width: 100%;
        min-height: 300px !important;
    }

    .chart-title.small {
        font-size: 12pt !important;
    }
</style>
